export default __webpack_public_path__ + "static/media/colorSplotchGold.c166c9eb.svg";